export function FeeStructure() {
  return (
    <section>
      <div className="mx-auto px-6 pt-16 pb-10 text-center lg:pt-32 lg:pb-40 lg:max-w-5xl">
        <h2 className="text-lg font-bold text-textblack text-center lg:text-4xl font-feature-settings pb-0 lg:pb-6">
          料金体系
        </h2>
        <p className="text-base text-textblack text-center font-feature-settings">
          お客様の課題やご予算などをヒアリングさせていただき、最適なプランを個別にご提案させて頂きます。
          <br />
          まずはお気軽にお問い合わせください。
        </p>
        <div className="flex justify-center my-10 lg:mt-14">
          <img
            decoding="async"
            src="/images/flow/img_fee_structure.svg"
            alt=""
          />
        </div>
      </div>
    </section>
  )
}
